// constants

import { PackagesActionTypes } from "./constants";

export interface PackageActionType {
  type:
    | PackagesActionTypes.API_RESPONSE_SUCCESS
    | PackagesActionTypes.API_RESPONSE_ERROR
    | PackagesActionTypes.GET_PACKAGES
    | PackagesActionTypes.UPDATE_PACKAGES
    | PackagesActionTypes.DELETE_PACKAGES
    | PackagesActionTypes.ADD_PACKAGES
    | PackagesActionTypes.CLEAR_ERROR;

  payload: {} | string;
}

export interface AddLocationPayload {
  id?: string;
  name: string;
  description: string;
  price: number;
  duration: number;
  swap: number;
  image: File[] | null | string;
  type: string;
}

export interface UpdateLocationPayload {
  id: string;
  data: any;
}

// common success
export const PackagesApiResponseSuccess = (actionType: string, data: any | {}): PackageActionType => ({
  type: PackagesActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const PackagesApiResponseError = (actionType: string, error: string): PackageActionType => ({
  type: PackagesActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get locations
export const getPackages = (): PackageActionType => ({
  type: PackagesActionTypes.GET_PACKAGES,
  payload: {},
});

export const deletePackages = (id: string): PackageActionType => ({
  type: PackagesActionTypes.DELETE_PACKAGES,
  payload: {
    id,
  },
});

export const updatePackage = (
  id: string,
  name: string,
  description: string,
  price: number,
  duration: number,
  image: File[] | null | string,
  type: string,
  status: string
): PackageActionType => ({
  type: PackagesActionTypes.UPDATE_PACKAGES,
  payload: { id, name, description, price, duration, image, type, status },
});

// add location
export const addPackage = (
  name: string,
  description: string,
  price: number,
  duration: number,
  image: File[] | null | string,
  type: string
): PackageActionType => ({
  type: PackagesActionTypes.ADD_PACKAGES,
  payload: { name, description, price, duration, image, type },
});

// clear error
export const clearPackageError = (): PackageActionType => ({
  type: PackagesActionTypes.CLEAR_ERROR,
  payload: {},
});
